<template>
  <vs-popup title="Safety Card 발급유형 기준" :active.sync="isActive" class="issue-type-popup">
    <div class="issue-type-criteria">
      <table>
        <colgroup>
          <col style="width: 90px" />
          <col style="width: calc((100% - 90px) / 3)" />
          <col style="width: calc((100% - 90px) / 3)" />
          <col style="width: calc((100% - 90px) / 3)" />
        </colgroup>
        <thead>
          <tr>
            <th></th>
            <th v-for="type in types" :key="`head-${type.name}`" :style="{ color: type.color }">{{ type.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in rows" :key="row.key">
            <th class="row-head">{{ row.label }}</th>
            <td v-for="type in types" :key="`${row.key}-${type.name}`">
              <ul>
                <li v-for="(item, itemIndex) in type[row.key]" :key="`${row.key}-${type.name}-${itemIndex}`">
                  <span class="check" :style="{ color: type.color }">&#10003;</span>
                  <!-- 항목 문자열은 컴포넌트 내부 상수라 v-html 사용 (밑줄 <u> 표기용) -->
                  <span class="item-text" v-html="item"></span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  computed: {
    isActive: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      rows: [
        { key: "요건", label: "발급요건 (모두 충족)" },
        { key: "사례", label: "주요 사례" },
        { key: "기준", label: "판단기준" },
      ],
      types: [
        {
          name: "Smart 안전관리",
          color: "#5b84b1",
          요건: ["기존 <u>인지·등록되지 않은 위험 발견</u>", "개선조치 Process 적정 연계", "발견된 위험의 내용 관련 특정 可"],
          사례: ["설비 이상, 방호장치 불량 등을 발견·신고하여 조치", "중요위험 수준의 <u>미등록 유해위험요인 신규 발굴 및 개선</u>"],
          기준: ["단순 발견이 아닌, 신고 등을 통한 <u>조치 Process 연결 여부</u>", "유해위험요인 실제 개선완료 여부"],
        },
        {
          name: "Safe 작업환경",
          color: "#4d9e94",
          요건: ["위험강도 또는 빈도가 상당히 감소하였을 것", "개선 전/후 상태 명확히 확인 可"],
          사례: [
            "작업방법 및 작업표준의 획기적 변경으로 위험도 저감",
            "설비적 개선으로 위험원 근본적 제거",
            "보조공구 자체 개선 등으로 위험원 접근 차단·제거",
          ],
          기준: ["실질적 실행여부 \n(개선완료, 설비안전위원회 채택 등)", "<u>타 공정 확대적용 가능여부</u>"],
        },
        {
          name: "Strong 안전문화",
          color: "#7d7d7d",
          요건: ["본인 外 타 근로자의 <u>안전의식 및 행동에 영향을 줄 것</u>", "일회성이 아닌 <u>지속적인 참여의 결과물일 것</u>"],
          사례: [
            "안전보건활동 우수자로서, 사업장 안전관리책임자가 인정하는 자 (비상훈련 우수, TBM 우수 등)",
            "사내 안전교육 강사활동을 통한 지속적인 안전 멘토링",
          ],
          기준: ["단순 참여가 아닌 <u>동료의 행동 또는 조직의 안전문화에 긍정적인 영향 유무 여부</u>"],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.issue-type-popup ::v-deep .vs-popup {
  width: 900px;
  max-width: 95vw;
}
.issue-type-criteria {
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    min-width: 640px;
    /* colgroup 지정 너비를 강제 (auto 레이아웃에서는 내용 길이에 따라 열 폭이 달라짐) */
    table-layout: fixed;
  }

  th,
  td {
    border: 1px solid #e0e0e0;
    padding: 8px 10px;
    vertical-align: top;
    font-size: 13px;
  }

  thead th {
    background: #f7f8fa;
    font-weight: 700;
    font-size: 14px;
    text-align: center;
  }

  .row-head {
    background: #f7f8fa;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    word-break: keep-all;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      gap: 6px;
      margin-bottom: 4px;
      line-height: 1.5;
      word-break: keep-all;

      .check {
        font-weight: 700;
        flex-shrink: 0;
      }

      .item-text {
        /* 항목 문자열의 \n 을 줄바꿈으로 표시 */
        white-space: pre-line;
      }

      .item-text ::v-deep u,
      .item-text u {
        text-underline-offset: 2px;
      }
    }
  }
}
</style>
